import { useState } from "react";
import { useSiteState } from "../../utils/useSiteState";
import { isSetupCompleted } from "../../components/ProjectDashboard/ProjectDashboard.utils";
import ProjectLaunchpad from "../../components/ProjectDashboard/ProjectLaunchpad";
import ProjectDashboardInfo from "../../components/ProjectDashboard/ProjectInformation";
import ProjectDashboardUsers from "../../components/ProjectDashboard/ProjectUsers";
import ProjectDashboardAnalytics from "../../components/ProjectDashboard/Analytics";

const SiteDashboard = () => {
  const { site } = useSiteState();

  const [setupCompleted] = useState(isSetupCompleted(site!));
  if (!setupCompleted) return <ProjectLaunchpad />;

  return (
    <>
      <title>{site!.title}</title>
      <div className="pt-10 max-w-5xl mx-auto grid grid-cols-5 gap-4 w-full h-[80%] text-white ">
        <div className="h-full w-full flex flex-col flex-shrink-0 col-span-3">
          <ProjectDashboardInfo />
          <div className="h-6 flex-shrink-0"></div>
          <ProjectDashboardUsers />
        </div>
        <ProjectDashboardAnalytics />
      </div>
    </>
  );
};

export default SiteDashboard;
